module.exports = __webpack_public_path__ + "media/images/front/banner_seminar20180729-18907f1350fd0cd4b28483fe10def021.jpg";